<template>
  <div class="d-flex flex-column px-4" style="gap: 1rem">
    <div>
      <p class="text-subtitle-2 mb-0">Faixa Etária</p>
      <p class="text-body-2 mb-0 text--secondary">
        <v-skeleton-loader v-if="loading" type="sentences" />
        <age-group-text v-else :party="party" />
      </p>
    </div>

    <div v-if="party?.requireDocuments">
      <p class="text-subtitle-2 mb-0">Documentos Necessários</p>
      <p class="text-body-2 text--secondary mb-0">
        {{ party.requireDocuments }}
      </p>
    </div>

    <div v-if="party?.dressCode">
      <p class="text-subtitle-2 mb-0">Normas de Vestimenta</p>
      <p class="text-body-2 text--secondary mb-0">
        {{ party?.dressCode }}
      </p>
    </div>

    <div v-if="party?.generalConditionsDocument">
      <p class="text-subtitle-2 mb-0">Condições Gerais</p>
      <p class="text-body-2 text--secondary mb-0">
        Clique no link abaixo para visualizar as condições gerais do evento.
      </p>
      <a
        v-if="!loading"
        :href="party?.generalConditionsDocument"
        target="_blank"
        class="primary--text text-12"
      >
        Ver condições gerais
      </a>
    </div>
    <div v-if="!hideRefundPolicy && !isFreeParty">
      <p class="text-subtitle-2 mb-0">Política de Reembolso</p>
      <p class="text-body-2 text--secondary mb-1">
        <v-skeleton-loader v-if="loading" type="paragraph" />
        <refund-policy-text v-else :party="party" />
      </p>
      <p v-if="!canBeRefunded" class="text-body-2 text--secondary mb-1 mt-1">
        Para compras realizadas a partir deste momento,
        <b>não será possível solicitar reembolso</b> pois o prazo para reembolso
        já expirou.
      </p>
      <a
        @click="refoundDialog = true"
        v-if="!loading"
        class="primary--text text-12"
      >
        Como solicitar reembolso?
      </a>
    </div>
    <div
      v-if="
        party?.refundPolicy &&
        decomposeRefundPolicy?.hoursToTransfer &&
        !isFreeParty
      "
    >
      <p class="text-subtitle-2 mb-0">Política de Transferência</p>
      <p class="text-body-2 mb-0 text--secondary">
        Após a confirmação do pagamento, você poderá transferir o ingresso para
        outra pessoa desde que esteja dentro do prazo de
        <b>{{ decomposeRefundPolicy?.hoursToTransfer }} horas antes do evento</b
        >.
      </p>
      <p class="text-body-2 mb-0 text--secondary">
        Alguns tipos de ingresso podem não permitir transferência. Entre em
        contato com nosso suporte para mais informações.
      </p>
    </div>

    <div v-if="party?.maxTickets && !isFreeParty">
      <p class="text-subtitle-2 mb-0">Política de vendas</p>
      <p class="text-body-2 mb-0 text--secondary">
        Esse evento tem um limite de {{ party.maxTickets }} ingresso{{
          party.maxTickets > 1 ? "s" : ""
        }}
        por pessoa.
      </p>
    </div>

    <div v-if="showHalfTicketPolicy">
      <p class="text-subtitle-2 mb-0">Benefício de meia entrada</p>
      <p class="text-body-2 mb-0 text--secondary">
        Todos os lotes de ingressos estão com reserva de 40% destinado ao
        atendimento da
        <a
          href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2013/lei/l12933.htm"
          target="_blank"
          class="primary--text"
          >lei 13.933/2013
          <v-icon x-small color="primary" style="margin-top: -2px">mdi-open-in-new</v-icon> </a
        >. Lotes onde não constar a emissão de meia entrada é porque houve o
        esgotamento de ingressos para meia entrada, devendo o cliente gerar a
        sua aquisição quando for disponibilizado novo lote. O cliente deverá
        apresentar documento compatível para utilização da meia entrada conforme
        normas estabelecidas em lei.
      </p>
    </div>

    <div v-if="party?.permitDocument">
      <p class="text-subtitle-2 mb-0">Alvará de funcionamento</p>
      <p class="text-body-2 text--secondary mb-0">
        É possível vizualizar o alvará de funcionamento cadastrado para o evento
      </p>
      <a
        v-if="!loading"
        @click="openPermitDocument"
        class="primary--text text-12"
      >
        Ver alvará de funcionamento
      </a>
    </div>

    <v-dialog v-model="refoundDialog" max-width="400px">
      <v-card>
        <v-card-title>Solicitação de Reembolso</v-card-title>
        <v-card-text>
          <p class="text-body-2">
            Para solicitar o reembolso, acesse o ingresso na nossa plataforma e
            vá até a seção "Pagamento". Clique no botão
            <v-btn icon small> <v-icon small>mdi-dots-vertical</v-icon> </v-btn>
            e, em seguida, selecione "Reembolso", preenchendo as informações
            necessárias.
          </p>

          <v-alert color="warning" text dense class="mb-4 text-14">
            Os pedidos de reembolso são avaliados pela organização do evento. Se
            estiver tudo certo, avisaremos você pelo WhatsApp.
          </v-alert>
          <p class="text-body-2 mb-0">
            Dúvidas? Fale conosco via
            <a @click="refundWhats" target="_blank">WhatsApp</a>.
          </p>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="refoundDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DescriptionWrap from "../global/DescriptionWrap.vue";
import AgeGroupText from "../global/party/AgeGroupText.vue";
import RefundPolicyText from "../global/party/RefundPolicyText.vue";
import RECORDER_SERVICE from "@/services/support/recorder";

import { settings } from "@/themeConfig";

export default {
  components: { DescriptionWrap, AgeGroupText, RefundPolicyText },
  data: () => ({
    refoundDialog: false,
    whatsappUrl: null,
    loadingWhatsapp: false,
    instance: null,
    settings,
  }),
  computed: {
    isFreeParty() {
      return !!this.party?.isFree;
    },
    hideRefundPolicy() {
      return this.settings?.hideRefundPolicy || false;
    },
    showHalfTicketPolicy() {
      return this.settings?.showHalfTicketPolicy || false;
    },
    decomposeRefundPolicy() {
      if (!this.party?.refundPolicy) return null;
      const [
        hoursBeforeEvent = null,
        hoursToTransfer = null,
        transferPolicy = null,
      ] = this.party.refundPolicy.split("-");
      return {
        hoursBeforeEvent: hoursBeforeEvent?.trim(),
        hoursToTransfer: hoursToTransfer?.trim(),
        transferPolicy: transferPolicy?.trim(),
      };
    },
    canBeRefunded() {
      const hours = this.decomposeRefundPolicy?.hoursBeforeEvent || 48;
      if (!hours || !this.party?.date) return true;

      const now = new Date();
      const eventDate = new Date(this.party?.date);
      const diffTime = eventDate.getTime() - now.getTime();
      const diffHours = Math.round(diffTime / (1000 * 60 * 60));
      return diffHours >= hours;
    },
  },
  methods: {
    async fetchInstance() {
      this.loadingWhatsapp = true;
      try {
        const response = await RECORDER_SERVICE.getInstanceById();
        this.instance = response.data[0];
        this.whatsappUrl = `https://api.whatsapp.com/send?phone=${
          this.instance.phone
        }&text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20um%20reembolso%20do%20evento%20${encodeURIComponent(
          this.party.name
        )}%20(${this.$options.filters.date(this.party.date, "DD/MM/YYYY")})`;
        window.open(this.whatsappUrl, "_blank");
      } catch (error) {
        console.error("Erro ao buscar instância:", error);
      } finally {
        this.loadingWhatsapp = false;
      }
    },
    refundWhats() {
      if (!this.whatsappUrl) {
        this.fetchInstance();
      } else {
        window.open(this.whatsappUrl, "_blank");
      }
    },
    openPermitDocument() {
      window.open(this.party.permitDocument, "_blank");
    },
  },
  props: {
    party: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
